
import { Component, Prop, Vue } from 'vue-property-decorator'

import type { EventDetails } from '@/api/types/processedEntities'
import Subtitle from '@/components/elements/Subtitle.vue'
import { type TixImage, imageData } from '@/helpers/ImageHelpers'
import { stripTrustedHTML, toKebabCase } from '@/helpers/StringHelpers'

@Component({
  name: 'EventListingItem',
  components: { Subtitle },
})
export default class extends Vue {
  @Prop()
  event: EventDetails

  @Prop()
  path: string

  get image(): TixImage {
    return imageData(this.event, 'teaser')
  }

  get categoryClass(): string | undefined {
    if (!this.event?.category) {
      return undefined
    }

    const category = stripTrustedHTML(this.event.category)

    return `category-${toKebabCase(category)}`
  }

  get linkTitle() {
    return this.$t('linkTitle', { name: stripTrustedHTML(this.event.name) })
  }
}
